import React from 'react';
import { Info, Wallet, CalendarClock } from 'lucide-react';

const CARDS = [
  {
    icon: Wallet,
    title: 'Du betaler ikke aconto til os',
    body: 'Hos enkel energi betaler du ikke et stort beløb på forhånd. Du betaler bagud for dit faktiske forbrug – din regning bygger på den strøm, du reelt har brugt, ikke på et gæt.',
  },
  {
    icon: CalendarClock,
    title: 'Første regning: 14. september 2026',
    body: 'Den dækker dit faktiske forbrug i august 2026. Du betaler os altså ikke noget før 1. oktober. Betalingsservice flyttes ikke automatisk fra Powerfuel – du kan tilmelde den, når din første regning kommer.',
  },
  {
    icon: Info,
    title: 'Aconto hos Powerfuel',
    body: 'Har du betalt for meget aconto hos Powerfuel, skal det håndteres af Powerfuel eller konkursboet. Beløbet overføres ikke til enkel energi, og vi kan ikke udbetale det. Et eventuelt krav anmeldes til kurator – find oplysninger via statstidende.dk.',
  },
];

export default function PowerfuelAconto() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a2e1a] mb-3" style={{ fontFamily: '"Playfair Display", Georgia, serif' }}>
              Betaling, aconto og din første regning
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Det spørgsmål, vi får oftest fra Powerfuel-kunder. Her er det korte svar.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-5">
            {CARDS.map((c, i) => {
              const Icon = c.icon;
              return (
                <div key={i} className="bg-[#f5f3ee] rounded-2xl border border-[#e8e4d9] p-6">
                  <div className="w-10 h-10 bg-[#1a2e1a] rounded-lg flex items-center justify-center mb-4">
                    <Icon className="w-5 h-5 text-[#eab308]" />
                  </div>
                  <h3 className="font-bold text-[#1a2e1a] text-base mb-2">{c.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{c.body}</p>
                </div>
              );
            })}
          </div>

          <p className="text-xs text-gray-500 mt-6 text-center max-w-2xl mx-auto leading-relaxed">
            Er du i tvivl, kan du skrive til os på <a href="mailto:hej@enkelenergi.dk" className="underline">hej@enkelenergi.dk</a>. Vi kan ikke føre din sag mod Powerfuel, men vi hjælper dig gerne med at forstå processen.
          </p>
        </div>
      </div>
    </section>
  );
}